import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useProps, useStore } from '../../utils/mobx.utils';
import BaseGrid from '../BaseGrid/BaseGrid';
import BaseGridCell from '../BaseGrid/BaseGridCell';
import FormContactTypeSelector from '../FormContactTypeSelector/FormContactTypeSelector';
import FormForm from '../FormForm/FormForm';
import FormInput from '../FormInput/FormInput';
import FormTelInput from '../FormTelInput/FormTelInput';
var ContactFormEditor = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get form() {
            return p.form;
        },
        handleBlur: function () {
            p.onBlur && p.onBlur(s.form.value);
            if (p.applyChangesOnBlur) {
                s.form.markAsSaved();
            }
        },
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement(FormForm, { className: "ContactFormEditor", form: s.form, onBlur: s.handleBlur, children: function (context) {
                var _a;
                return React.createElement(BaseGrid, { columns: ((_a = context.resizeQuery) === null || _a === void 0 ? void 0 : _a.fromPhoneLg) ? 2 : 1 },
                    React.createElement(FormInput, { field: "email", label: "Email", type: "email", required: p.requireEmail, dataCy: "email", autoComplete: "off" }),
                    React.createElement(FormTelInput, { field: "phone", label: "Phone", required: p.requireMobileNumber, dataCy: "phone", autoComplete: "off", optional: true, doNotUseAPIValidation: true, doNotUseOnMountGetUserDialCode: true }),
                    React.createElement(FormInput, { field: "name", label: "Your name", dataCy: "name", autoComplete: "off", required: p.requireName }),
                    React.createElement(FormContactTypeSelector, { field: "type", label: "Select the closest topic", dataCy: "type", required: true }),
                    React.createElement(BaseGridCell, { columns: "all" },
                        React.createElement(FormInput, { field: "body", label: "Enter a message", placeholder: "Enter a message", type: "textarea", rows: "10", required: true })));
            } })); } });
};
export default ContactFormEditor;
